<template>
  <div class="new_vip">
    <div class="title_line">
      <el-page-header @back="goBack" content="交班"></el-page-header>
    </div>
    <div class="content">
      <div class="options">
        <div class="options_item">
          <span class="options_label">门店</span>
          <el-select size="small" v-model="roomid" class="select_box" clearable>
            <el-option
              v-for="item in roomList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            style="margin-left:10px;"
            size="small"
            v-model="dates"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <el-button
            style="margin-left:10px;"
            type="primary"
            size="small"
            @click="search"
            >查询</el-button
          >
          <el-button size="small" @click="del_Handovers(1)">删除</el-button>
          <el-button size="small" @click="del_Handovers(2)"
            >时间段删除</el-button
          >
        </div>
      </div>
      <div class="table_box">
        <el-table
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          @selection-change="Select_Handover"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="交班门店" prop="room_name"></el-table-column>
          <el-table-column label="新增会员" prop="inc_num"></el-table-column>
          <el-table-column
            label="售卡金额"
            prop="sale_card_amount"
          ></el-table-column>
          <el-table-column
            label="充值总额"
            prop="ex_goods_amount"
          ></el-table-column>
          <el-table-column
            label="消费总额"
            prop="goods_amount"
          ></el-table-column>
          <el-table-column label="现金支付" prop="cash">
            <template slot-scope="scope">
              <span>{{
                (
                  Number(scope.row.cash) +
                  Number(
                    scope.row.creditshop_order_data
                      ? scope.row.creditshop_order_data.cash_money
                      : 0
                  )
                ).toFixed(2)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="余额支付" prop="balance"></el-table-column>
          <el-table-column label="银联支付">
            <template slot-scope="scope">
              <span>{{
                (
                  Number(scope.row.unionpay_amount) +
                  Number(scope.row.wechat_pay) +
                  Number(
                    scope.row.creditshop_order_data
                      ? scope.row.creditshop_order_data.online_money
                      : 0
                  )
                ).toFixed(2)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="create_time"
            width="150px"
          ></el-table-column>
          <el-table-column
            label="班次时间"
            prop="show_time"
            width="290px"
          ></el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="historyDetail(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            layout="prev, pager, next, total"
            :current-page="page"
            :total="total"
            :page-size="10"
            background
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showDetail"
      @close="showDetail = false"
      title="交班详情"
      width="950px"
    >
      <check-detail
        v-if="detailMsg.duty_type == 1"
        :DutyType="DutyType"
        :isCheck="true"
        ref="checkDetailnewOld"
      ></check-detail>
      <check-detailnew
        v-if="detailMsg.duty_type == 2"
        :DutyType="DutyType"
        :isCheck="true"
        ref="checkDetailnew"
      ></check-detailnew>
    </el-dialog>
    <el-dialog
      :visible.sync="showEmployeeDetail"
      @close="showEmployeeDetail = false"
    >
      <Stat :statData="employeeDetailData"></Stat>
    </el-dialog>
    <el-dialog
      title="删除操作"
      width="500px"
      :visible.sync="delete_duty"
      @close="closeBatchPopup"
    >
      <div
        style="display: flex; margin: 10px 0"
        v-if="config.open_delete_duty == 1"
      >
        <div>验证码：</div>
        <el-input size="small" v-model="verification_code" style="width: 220px">
          <template slot="append">
            <el-link :disabled="btn_status" @click="getCode" type="primary">{{
              code_text
            }}</el-link>
          </template>
        </el-input>
      </div>
      <el-button type="" @click="delete_duty = false">取消</el-button>
      <el-button type="primary" @click="del">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { duty_config, get_safeinfo, SendAdminCode } from "@/api/set";
import { hideLoading, showLoading } from "@/utils/loading";
import { changeDuty_del, changeDutyList } from "@/api/vip";
import { storeSelect } from "@/api/employee";
import CheckDetail from "./changeDutyNew";
import CheckDetailnew from "./changeDutyNew2";
import Stat from "@/components/vip/changeDutyStat";
import time from '@/utils/time'

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    Stat,
    CheckDetail,
    CheckDetailnew,
  },
  data() {
    return {
      code_text: "获取验证码",
      btn_status: false,
      verification_code: "",
      status: 1,
      delete_duty: false,
      dates: [],
      tableData: [], //交班记录列表
      page: 1,
      times:1646193600,
      total: 0,
      roomid: "",
      roomList: [], //门店列表
      doneList: [], //员工信息列表
      showDetail: false, //显示列表详情
      showEmployeeDetail: false, //显示员工详情
      employeeDetailData: {}, //员工详情
      headerStyle: {
        //表头样式
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
      detailMsg: {},
      handover: [],
      config: {},
      timer: null,
      count: 0,
      DutyType: {},
    };
  },
  mounted() {
    this.init();
    this.getData();
  },
  methods: {
    //关闭弹窗
    closeBatchPopup() {
      this.delete_duty = false;
      this.dates = [];
      this.handover = [];
      this.verification_code = "";
    },
    //管理员安全验证码
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //获取验证码
    async getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    //获取安全设置
    async get_config() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          this.config = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    setHeader({ rowIndex }) {
      // 设置表头颜色
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    //选择交班记录
    Select_Handover(val) {
      console.log("已选择", val);
      this.handover = val;
    },
    //多选删除
    del_Handovers(key) {
      console.log("key", key);
      if (key == 1) {
        this.dates = [];
        if (this.handover.length == 0) {
          return this.$message("选择一条记录");
        }
      } else {
        this.handover = [];
        if (this.dates.length < 1) {
          return this.$message("选择时间段");
        }
      }
      if (this.config.open_delete_duty == 1) {
        this.delete_duty = true;
      } else {
        this.del();
      }
    },
    del() {
      let id = "";
      let arr = [];
      let data = {
        app_id: this.app_id,
      };
      if (this.handover.length == 1) {
        id = this.handover[0].id;
      } else if (this.handover.length > 1) {
        this.handover.forEach((item, i) => {
          arr.push(item.id);
        });
        id = arr.join(",");
      }
      let str = "";
      if (id !== "") {
        data.id = id;
      }
      if (this.config.open_delete_duty == 1) {
        data.verification_code = this.verification_code;
      }
      if (this.dates) {
        if (this.dates.length == 2) {
          data.create_time_s = this.dates[0];
          data.create_time_e = this.dates[1];
          str = this.dates[0] + "至" + this.dates[1] + "的记录";
        }
      }
      this.$confirm(`确定执行删除?此操作会永久删除${str}`, "删除操作", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          changeDuty_del(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.dates = [];
              this.handover = [];
              this.delete_duty = false;
              this.page = 1;
              this.getData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message("取消删除");
        });
    },
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      storeSelect(data).then((res) => {
        if (res.code == 200) {
          this.roomList = res.data;
        } else {
          this.roomList = [];
        }
      });
      duty_config({ app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.DutyType = res.data;
        }
      });
      this.get_config();
    },
    search() {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.handover = [];
      //获取表格数据
      showLoading();
      console.log(this.roomid);
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        // room_id: this.roomid || this.$route.query.roomid
      };
      if (this.roomid != "") {
        data.room_id = this.roomid;
      }
      if (this.dates) {
        if (this.dates.length == 2) {
          data.create_time_s = this.dates[0];
          data.create_time_e = this.dates[1];
        }
      }
      changeDutyList(data).then((res) => {
        if (res.code == 200) {
          if (res.data.result) {
            this.total = res.data.total_num;
            this.tableData = res.data.result;
            this.tableData.forEach((item) => {
              item.show_time = item.begintime + " ~ " + item.endtime;
            });
          }
          hideLoading();
        } else {
          this.$message(res.msg);
          hideLoading();
        }
      });
    },
    handleCurrentChange(val) {
      //跳页
      this.page = val;
      this.getData();
    },
    historyDetail(row) {
      console.log("0000", row);
      this.detailMsg = Object.assign({}, row);
      console.log("555555", this.detailMsg);
      this.detailMsg.total_all = (
        Number(this.detailMsg.preferential_money) +
        Number(this.detailMsg.goods_amount)
      ).toFixed(2);
      if (row.duty_type == 2) {
        this.detailMsg.new_duty_param.begintime = this.detailMsg.begintime;
        this.detailMsg.new_duty_param.endtime = this.detailMsg.endtime;
      }
      this.showDetail = true;
      this.$nextTick(() => {
        if (row.duty_type == 2) {
          this.$refs.checkDetailnew.tl_free = 0;
          this.$refs.checkDetailnew.fuiou_free = 0;
          let new_duty_param = this.detailMsg.new_duty_param;
          this.$refs.checkDetailnew.detailData = Object.assign(
            {},
            new_duty_param
          );
          console.log("shuju", new_duty_param);
          this.$refs.checkDetailnew.room_name = new_duty_param.room_name;
          console.log('0000',time.Time_stamp(row.create_time))
          let Times = time.Time_stamp(row.create_time)
          if(Times>this.times){
            this.$refs.checkDetailnew.time = 1
          }
          let emps = new_duty_param.emp||[]
          this.$refs.checkDetailnew.empList = []
          this.$refs.checkDetailnew.empNormalList = []
          emps.forEach((e) => {
            if (e.emp_order_amount != 0) {
              this.$refs.checkDetailnew.empList.push(e)
            }
            if (e.emp_normal_amount != 0) {
              this.$refs.checkDetailnew.empNormalList.push(e)
            }
          })

          // this.$refs.checkDetailnew.empList = new_duty_param.emp;
          this.$refs.checkDetailnew.nowDate =
            new_duty_param.begintime + " ~ " + new_duty_param.endtime;
          this.$refs.checkDetailnew.totalNum = (
            Number(new_duty_param.count.cash) +
            Number(new_duty_param.count.unionpay) +
            Number(new_duty_param.count.wxpay)
          ).toFixed(2);
          this.$refs.checkDetailnew.settelment = new_duty_param.settelment || {
            settle: {},
          };
          this.$refs.checkDetailnew.settelment.tl_settle_amount = Number(
            new_duty_param.settelment.tl_settle_amount
          );
          this.$refs.checkDetailnew.settle = new_duty_param.settelment.settle;
          console.log(this.$refs.checkDetailnew.settle);
          this.$refs.checkDetailnew.normal = new_duty_param.count.normal;
          console.log("normal_num", new_duty_param.count.normal);
          this.$refs.checkDetailnew.creditshop_data =
            new_duty_param.creditshop_order_data || {};
          this.$refs.checkDetailnew.settelment.tl_collection =
            new_duty_param.settelment.tl_collection || [];
          if (
            new_duty_param.settelment.tl_collection &&
            new_duty_param.settelment.tl_collection.length > 0
          ) {
            new_duty_param.settelment.tl_collection.forEach((e) => {
              if (e.amount && e.amount > 0) {
                this.$refs.checkDetailnew.tl_free++;
              }
            });
          }
        }
        if (row.duty_type == 1) {
          console.log("deta", row);
          this.$refs.checkDetailnewOld.detailData = Object.assign(
            {},
            row,
            row.platform_card_order_data
          );
          console.log(
            "shuju",
            Object.assign({}, this.$refs.checkDetailnewOld.detailData)
          );
          this.$refs.checkDetailnewOld.normal_order = row.normal;
          this.$refs.checkDetailnewOld.room_name = row.room_name;
          this.$refs.checkDetailnewOld.settelment = row.settlement || {
            settle: {},
          };
          this.$refs.checkDetailnewOld.creditshop_data =
            row.creditshop_order_data || {};
          this.$refs.checkDetailnewOld.settle = this.$refs.checkDetailnewOld.settelment.settle;
          console.log(this.settle);
          this.$refs.checkDetailnewOld.detailData.unionpay =
            row.unionpay_amount;
          this.$refs.checkDetailnewOld.detailData.free_amount =
            row.preferential_money;
          this.$refs.checkDetailnewOld.detailData.total_amount =
            row.goods_amount;
          this.$refs.checkDetailnewOld.detailData.gasoli_discount =
            row.gasoli_order_money == "0"
              ? "0"
              : (
                  Number(row.gasoli_order_money) - Number(row.gasoli_amount)
                ).toFixed(2);
          this.$refs.checkDetailnewOld.detailData.diesel_discount =
            row.diesel_order_money == "0"
              ? "0"
              : (
                  Number(row.diesel_order_money) - Number(row.diesel_amount)
                ).toFixed(2);
          this.$refs.checkDetailnewOld.formData.amount = row.cash;
          this.$refs.checkDetailnewOld.formData.pretty_cash = row.pretty_cash;
          this.$refs.checkDetailnewOld.formData.down_money = row.down_money;
          this.$refs.checkDetailnewOld.formData.hand_money = row.hand_money;
          this.$refs.checkDetailnewOld.nowDate =
            row.begintime + " ~ " + row.endtime;
          this.$refs.checkDetailnewOld.detailData.show_recharge_unionpay_amount = (
            Number(row.ex_unionpay_amount) +
            Number(row.ex_wechat_pay_amount) +
            Number(row.ex_ali_pay_amount)
          ).toFixed(2);
          this.$refs.checkDetailnewOld.detailData.show_order_unionpay_amount = (
            Number(row.wechat_pay) +
            Number(row.ali_pay) -
            Number(row.ex_ali_pay_amount) -
            Number(row.ex_wechat_pay_amount) -
            Number(row.normal ? row.normal.normal_wxpay : 0) +
            Number(row.consume_unionpay_amount)
          ).toFixed(2);
          this.$refs.checkDetailnewOld.detailData.show_unionpay_total = (
            Number(row.unionpay_amount) +
            Number(row.wechat_pay) +
            Number(row.ali_pay)
          ).toFixed(2);
          this.$refs.checkDetailnewOld.detailData.show_all_recharge = (
            Number(row.oil_card_money) +
            Number(row.family_card_money) +
            Number(row.car_card_money) +
            Number(row.balance)
          ).toFixed(2);
        }
      });
    },
    employeeDetail(row) {
      //交班员工详细
      console.log(row);
      this.employeeDetailData = row;
      this.showEmployeeDetail = true;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .title_line {
    height: 34px;
  }
  .content {
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    .options {
      line-height: 50px;
      margin-bottom: 15px;
      display: flex;
      .options_item {
        margin-left: 15px;
        .select_box {
          width: 200px;
        }
        .options_label {
          margin-right: 11px;
        }
      }
    }
    .table_box {
      flex: 1;
    }
    .page {
      margin-top: 15px;
    }
  }
}
</style>
